function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { StateHandler, controllerMixin, Messaging } from 'oskari-ui/util';
import { groupLayers } from './util';
import { FILTER_ALL_LAYERS } from '..';
import { GROUPING_PRESET, GROUPING_DATAPROVIDER } from '../preset';
var ANIMATION_TIMEOUT = 400;
var LAYER_REFRESH_THROTTLE = 2000;
var GROUPING_METHODS = {};
GROUPING_PRESET.forEach(function (preset) {
  GROUPING_METHODS[preset.key] = preset.method;
});

/* ------------- Helpers to determine group structure based on layers and groups on maplayerservice ------ */
var _getLayerGroups = function getLayerGroups() {
  var groups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return groups.map(function (group) {
    return {
      id: group.id,
      name: group.getName(),
      description: group.getDescription(),
      layers: group.getChildren().filter(function (c) {
        return c.type === 'layer';
      }) || [],
      groups: _getLayerGroups(group.getGroups())
    };
  });
};
var providerReducer = function providerReducer(accumulator, currentLayer) {
  var id = currentLayer.getDataProviderId();
  if (!id) {
    return accumulator;
  }
  var dataProviderId = '' + id;
  var orgLayers = accumulator[dataProviderId] || [];
  if (!orgLayers.length) {
    accumulator[dataProviderId] = orgLayers;
  }
  orgLayers.push({
    id: currentLayer.getId()
  });
  return accumulator;
};
var getDataProviders = function getDataProviders() {
  var providers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var layers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  // Note! providers will be an empty array before layer listing has been loaded/populated
  // get layers by provider { providerId: [... list of layer ids for provider...]}
  var layersByProvider = layers.reduce(providerReducer, {});
  return providers.map(function (dataProvider) {
    var name = dataProvider.name;
    return {
      id: dataProvider.id,
      name: name,
      description: dataProvider.desc,
      layers: layersByProvider['' + dataProvider.id] || [],
      groups: []
    };
  });
};

/**
 * Filters an array of groups and checks if layers in them match the input for "searchText".
 * Also recurses into subgroups to check layers in them.
 * @param {Oskari.mapframework.bundle.layerselector2.model.LayerGroup[]} groups an array of groups to filter by searchText
 * @param {String} searchText input to filter by. If empty or "falsy" the groups param is returned as-is.
 * @returns Removes any groups/subgroups that don't have layers matching the searchText.
 */
var _filterGroups = function filterGroups() {
  var groups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var searchTerms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!searchTerms.length) {
    return groups;
  }
  return groups.map(function (group) {
    group.unfilteredLayerCount = group.getLayerCount();
    group.layers = group.layers.filter(function (lyr) {
      return group.matchesKeyword(lyr.getId(), searchTerms);
    });
    group.groups = _filterGroups(group.groups, searchTerms);
    if (!group.getLayerCount()) {
      // no layers and no subgroups with layers
      return null;
    }
    return group;
  }).filter(function (group) {
    return !!group;
  });
};

/* ------------- /Helpers ------ */

/**
 * Holds and mutates layer list state.
 * Handles events related to layer listing.
 */
var ViewHandler = /*#__PURE__*/function (_StateHandler) {
  function ViewHandler(instance) {
    var _this;
    var groupingType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : GROUPING_PRESET[0].key;
    _classCallCheck(this, ViewHandler);
    _this = _callSuper(this, ViewHandler);
    _this.sandbox = instance.getSandbox();
    _this.loc = instance.getLocalization();
    _this.mapLayerService = _this.sandbox.getService('Oskari.mapframework.service.MapLayerService');
    _this.mapLayerService.on('theme.update', function () {
      return _this.updateLayerGroups();
    });
    _this.mapLayerService.on('dataProvider.update', function () {
      return _this.updateLayerGroups();
    });
    _this.toolingService = _this.sandbox.getService('Oskari.mapframework.service.LayerListToolingService');
    _this.toolingService.on('add', function () {
      return _this.updateLayerGroups();
    });
    _this.map = _this.sandbox.getMap();
    _this.groupingType = groupingType;
    _this.filter = {
      activeId: FILTER_ALL_LAYERS,
      text: null
    };
    _this.state = {
      groups: [],
      openGroupTitles: [],
      selectedLayerIds: _this._getSelectedLayerIds(),
      selectedGroupIds: []
    };
    _this.eventHandlers = _this._createEventHandlers();
    return _this;
  }
  _inherits(ViewHandler, _StateHandler);
  return _createClass(ViewHandler, [{
    key: "setGroupingType",
    value: function setGroupingType() {
      var groupingType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : GROUPING_PRESET[0].key;
      if (this.groupingType === groupingType) {
        // grouping stays the same
        return;
      }
      this.groupingType = groupingType;
      this.updateLayerGroups();
    }
  }, {
    key: "setFilter",
    value: function setFilter(activeId) {
      var searchText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var previousSearchText = this.filter.searchText;
      // Generate search terms by splitting by * and space
      // Opening layerlist with request might send searchText as null
      //  so we need to make sure it's string before processing it.
      //  Nulls are not changed to function param default values, this is required even with default value.
      var normalizedQuery = searchText || '';
      var terms = normalizedQuery.replaceAll('*', ' ').replaceAll(',', ' ').split(' ').filter(function (item) {
        return item !== '';
      });
      this.filter = {
        activeId: activeId,
        normalizedQuery: normalizedQuery,
        terms: terms
      };
      this.updateLayerGroups();
      if (searchText !== previousSearchText) {
        if (searchText) {
          // open all groups
          var _flatten = function flatten(groups) {
            return groups.flatMap(function (g) {
              return [g].concat(_toConsumableArray(_flatten(g.getGroups())));
            });
          };
          var allGroupsIds = _flatten(this.state.groups).map(function (g) {
            return g.getId();
          });
          this.updateState({
            openGroupTitles: allGroupsIds
          });
        } else {
          // close all groups
          this.updateState({
            openGroupTitles: []
          });
        }
      }
    }
  }, {
    key: "_getSelectedLayerIds",
    value: function _getSelectedLayerIds() {
      return this.map.getLayers().map(function (layer) {
        return layer.getId();
      });
    }
  }, {
    key: "addLayer",
    value: function addLayer(id) {
      var _this2 = this;
      if (!id || this.state.selectedLayerIds.includes(id)) {
        return;
      }
      var layer = this.mapLayerService.findMapLayer(id);
      if (layer && !layer.isVisible()) {
        Messaging.notify(this.loc.layer.hiddenNotification);
      }
      var selectedLayerIds = [].concat(_toConsumableArray(this.state.selectedLayerIds), [id]);
      this.updateState({
        selectedLayerIds: selectedLayerIds
      });
      // Adding a map layer can be a resource exhausting task.
      // Delay request to allow switch animation play smoothly.
      setTimeout(function () {
        return _this2.sandbox.postRequestByName('AddMapLayerRequest', [id]);
      }, ANIMATION_TIMEOUT);
    }
  }, {
    key: "removeLayer",
    value: function removeLayer(id) {
      var _this3 = this;
      var index = this.state.selectedLayerIds.indexOf(id);
      if (index === -1) {
        return;
      }
      var selectedLayerIds = _toConsumableArray(this.state.selectedLayerIds);
      selectedLayerIds.splice(index, 1);
      this.updateState({
        selectedLayerIds: selectedLayerIds
      });
      setTimeout(function () {
        return _this3.sandbox.postRequestByName('RemoveMapLayerRequest', [id]);
      }, ANIMATION_TIMEOUT);
    }

    // active all layers in selected group
  }, {
    key: "addGroupLayersToMap",
    value: function addGroupLayersToMap(group) {
      var _this4 = this;
      var _loop = function _loop(i) {
        if (!group.layers[i]._id || _this4.state.selectedLayerIds.includes(group.layers[i]._id)) {
          return 1; // continue
        }
        var selectedLayerIds = [].concat(_toConsumableArray(_this4.state.selectedLayerIds), [group.layers[i]._id]);
        _this4.updateState({
          selectedLayerIds: selectedLayerIds
        });
        setTimeout(function () {
          return _this4.sandbox.postRequestByName('AddMapLayerRequest', [group.layers[i]._id]);
        }, ANIMATION_TIMEOUT);
      };
      for (var i in group.layers) {
        if (_loop(i)) continue;
      }
    }

    // deactivate all layers in group
  }, {
    key: "removeGroupLayersFromMap",
    value: function removeGroupLayersFromMap(group) {
      var _this5 = this;
      var _loop2 = function _loop2(i) {
        var index = _this5.state.selectedLayerIds.indexOf(group.layers[i]._id);
        if (index === -1) {
          return 1; // continue
        }
        var selectedLayerIds = _toConsumableArray(_this5.state.selectedLayerIds);
        selectedLayerIds.splice(index, 1);
        _this5.updateState({
          selectedLayerIds: selectedLayerIds
        });
        setTimeout(function () {
          return _this5.sandbox.postRequestByName('RemoveMapLayerRequest', [group.layers[i]._id]);
        }, ANIMATION_TIMEOUT);
      };
      for (var i in group.layers) {
        if (_loop2(i)) continue;
      }
    }
  }, {
    key: "updateLayerGroups",
    value: function updateLayerGroups() {
      var _this$filter = this.filter,
        terms = _this$filter.terms,
        filterId = _this$filter.activeId;
      var isPresetFiltered = filterId !== FILTER_ALL_LAYERS;
      var layers = !isPresetFiltered ? this.mapLayerService.getAllLayers() : this.mapLayerService.getFilteredLayers(filterId);
      var tools = Object.values(this.toolingService.getTools()).filter(function (tool) {
        return tool.getTypes().includes('layergroup');
      });

      // For admin users all groups and all data providers are provided to groupLayers function to include possible empty groups to layerlist.
      // For non admin users empty arrays are provided and with this empty groups are not included to layerlist.
      var groupsToProcess = [];
      var isDataProviders = this.groupingType === GROUPING_DATAPROVIDER;
      // normalize groups and dataproviders structure
      if (!isDataProviders) {
        groupsToProcess = _getLayerGroups(this.mapLayerService.getAllLayerGroups());
      } else {
        groupsToProcess = getDataProviders(this.mapLayerService.getDataProviders(), layers);
      }
      var groups = groupLayers(_toConsumableArray(layers), GROUPING_METHODS[this.groupingType], tools, groupsToProcess, this.loc.grouping.noGroup, isPresetFiltered);
      this.updateState({
        groups: _filterGroups(groups, terms)
      });
    }
  }, {
    key: "updateOpenGroupTitles",
    value: function updateOpenGroupTitles(openGroupTitles) {
      this.updateState({
        openGroupTitles: openGroupTitles
      });
    }
  }, {
    key: "updateSelectedLayerIds",
    value: function updateSelectedLayerIds() {
      var selectedLayerIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._getSelectedLayerIds();
      this.updateState({
        selectedLayerIds: selectedLayerIds
      });
    }
  }, {
    key: "showLayerBackendStatus",
    value: function showLayerBackendStatus(layerId) {
      this.sandbox.postRequestByName('ShowMapLayerInfoRequest', [layerId]);
    }

    /// Oskari event handling ////////////////////////////////////////////////////////////

    /**
     * "Module" name for event handling
     */
  }, {
    key: "getName",
    value: function getName() {
      return 'LayerCollapse.CollapseService';
    }

    /**
    * @method onEvent
    * @param {Oskari.mapframework.event.Event} event a Oskari event object
    * Event is handled forwarded to correct #eventHandlers if found or discarded if not.
    */
  }, {
    key: "onEvent",
    value: function onEvent(event) {
      var handler = this.eventHandlers[event.getName()];
      if (!handler) {
        return;
      }
      return handler.apply(this, [event]);
    }
  }, {
    key: "_createEventHandlers",
    value: function _createEventHandlers() {
      var _this6 = this;
      var sandbox = Oskari.getSandbox();
      var throttleRefreshAll = Oskari.util.throttle(this._refreshAllLayers.bind(this), LAYER_REFRESH_THROTTLE, {
        leading: false
      });
      var throttleGroupUpdate = Oskari.util.throttle(this.updateLayerGroups.bind(this), LAYER_REFRESH_THROTTLE, {
        leading: false
      });
      var handlers = {
        'MapLayerEvent': function MapLayerEvent(event) {
          var layerId = event.getLayerId();
          var operation = event.getOperation();
          if (operation === 'sticky') {
            _this6._refreshLayer(layerId);
          } else if (['add', 'remove', 'update'].includes(operation)) {
            // heavy op -> throttle
            throttleGroupUpdate();
          } else if (operation === 'tool') {
            if (layerId) {
              _this6._refreshLayer(layerId);
              return;
            }
            // heavy op -> throttle
            throttleRefreshAll();
          }
        },
        'AfterMapLayerRemoveEvent': function AfterMapLayerRemoveEvent() {
          return _this6.updateSelectedLayerIds();
        },
        'AfterMapLayerAddEvent': function AfterMapLayerAddEvent() {
          return _this6.updateSelectedLayerIds();
        },
        'BackendStatus.BackendStatusChangedEvent': function BackendStatusBackendStatusChangedEvent(event) {
          if (event.getLayerId()) {
            _this6._refreshLayer(event.getLayerId());
          } else {
            throttleRefreshAll();
          }
        }
      };
      Object.getOwnPropertyNames(handlers).forEach(function (p) {
        return sandbox.registerForEventByName(_this6, p);
      });
      return handlers;
    }
  }, {
    key: "_refreshLayer",
    value: function _refreshLayer(id) {
      if (!id || this.state.groups.length === 0) {
        return;
      }
      var groups = this.state.groups.map(function (group) {
        var layer = group.layers.find(function (lyr) {
          return lyr.getId() === id;
        });
        if (!layer) {
          return group;
        }
        return group.clone();
      });
      this.updateState({
        groups: groups
      });
    }
  }, {
    key: "_refreshAllLayers",
    value: function _refreshAllLayers() {
      if (this.state.groups.length === 0) {
        return;
      }
      // Clone all groups and layers to ensure rerendering.
      var groups = this.state.groups.map(function (cur) {
        return cur.clone();
      });
      this.updateState({
        groups: groups
      });
    }
  }]);
}(StateHandler);
export var LayerCollapseHandler = controllerMixin(ViewHandler, ['addLayer', 'removeLayer', 'updateOpenGroupTitles', 'updateLayerGroups', 'updateSelectedLayerIds', 'showLayerBackendStatus', 'addGroupLayersToMap', 'removeGroupLayersFromMap', 'showWarn', 'deactivateGroup']);